export interface ShouldArmBarrierForListTopReturnInput {
	previousY: number;
	y: number;
	maxOffset: number;
	buffer: number;
}

export function shouldArmBarrierForListTopReturn({
	previousY,
	y,
	maxOffset,
	buffer
}: ShouldArmBarrierForListTopReturnInput): boolean {
	return previousY > maxOffset + buffer && y <= maxOffset;
}
